import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CheckoutCancelPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-4" data-testid="checkout-cancel-page">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <XCircle className="w-16 h-16 text-[#E28743] mx-auto mb-4" />
        <h1 className="font-serif text-2xl text-[#2D231E] mb-2" data-testid="cancel-title">
          Pedido Cancelado
        </h1>
        <p className="text-[#5C4D43] mb-6">
          Has cancelado el proceso de pago. Tu carrito sigue guardado si deseas completar tu pedido más tarde.
        </p>
        <Link to="/">
          <Button 
            className="btn-primary px-8 py-3"
            data-testid="continue-shopping-btn"
          >
            Continuar Comprando
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default CheckoutCancelPage;
